import React, {Component} from 'react';
import './ProfileNotifications.css';

class ProfileNotifications extends Component {
    static propTypes = {};
    static defaultProps = {};
    state = {
        isDesktopEnabled: false,
        isTelegramEnabled: false,
        isViberEnabled: false
    };

    render() {
        return (
            <form>
                <div className="row">
                    <div className="col-md-12">
                        <fieldset className="form-group">
                            <div className="form-group">
                                {
                                    !this.state.isDesktopEnabled &&
                                    <button type="button" className="btn btn-primary"
                                            onClick={() => this.setState({isDesktopEnabled: true})}>
                                        <span className="btn-label-icon left fa fa-bell"/>Включить уведомления на
                                        рабочем столе
                                    </button>
                                }
                                {
                                    this.state.isDesktopEnabled &&
                                    <div>
                                        <span className="btn btn-success">
                                            <span className="btn-label-icon left fa fa-bell"/>Уведомления на рабочем столе включены
                                        </span>
                                        <button type="button" class="btn btn-danger btn-outline m-l-1">Отключить
                                        </button>
                                    </div>
                                }
                            </div>
                        </fieldset>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <fieldset className="form-group">
                            <div className="form-group">
                                {
                                    !this.state.isTelegramEnabled &&
                                    <button type="button" className="btn btn-primary"
                                            onClick={() => this.setState({isTelegramEnabled: true})}>
                                        <span className="btn-label-icon left fa fa-telegram"/>Включить уведомления в
                                        Telegram
                                    </button>
                                }
                                {
                                    this.state.isTelegramEnabled &&
                                    <div>
                                        <span className="btn btn-success">
                                            <span className="btn-label-icon left fa fa-telegram"/>Уведомления в Telegram включены
                                        </span>
                                        <button type="button" class="btn btn-danger btn-outline m-l-1">Отключить
                                        </button>
                                    </div>
                                }
                            </div>
                        </fieldset>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <fieldset className="form-group">
                            <div className="form-group">
                                {
                                    !this.state.isViberEnabled &&
                                    <button type="button" className="btn btn-primary"
                                            onClick={() => this.setState({isViberEnabled: true})}>
                                        <span className="btn-label-icon left fa fa-viber"/>Включить уведомления в Viber
                                    </button>
                                }
                                {
                                    this.state.isViberEnabled &&
                                    <div>
                                        <span className="btn btn-success">
                                            <span className="btn-label-icon left fa fa-viber"/>Уведомления в Viber включены
                                        </span>
                                        <button type="button" class="btn btn-danger btn-outline m-l-1">Отключить
                                        </button>
                                    </div>
                                }
                            </div>
                        </fieldset>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="panel">
                            <div className="panel-title"><strong>Мгновенные уведомления</strong></div>
                            <div className="panel-body">
                                <table className="table">
                                    <thead>
                                    <tr>
                                        <th className="p-a-2"></th>
                                        <th className="p-a-2">Email</th>
                                        <th className="p-a-2">SMS</th>
                                        <th className="p-a-2">В мобильном приложении</th>
                                        <th className="p-a-2">На рабочем столе</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td className="p-a-2">Вы выиграли тендер</td>
                                        <td className="p-a-2 valign-middle">
                                            <label className="switcher switcher-success">
                                                <input type="checkbox"
                                                       onchange="$.growl.success({title:'Успех',message:'Настройки уведомлений успешно изменены'})"/>
                                                <div className="switcher-indicator">
                                                    <div className="switcher-yes">ВКЛ</div>
                                                    <div className="switcher-no">ВЫКЛ</div>
                                                </div>
                                            </label>
                                        </td>
                                        <td className="p-a-2 valign-middle">
                                            <label className="switcher switcher-success">
                                                <input type="checkbox"/>
                                                <div className="switcher-indicator">
                                                    <div className="switcher-yes">ВКЛ</div>
                                                    <div className="switcher-no">ВЫКЛ</div>
                                                </div>
                                            </label>
                                        </td>
                                        <td className="p-a-2 valign-middle">
                                            <label className="switcher switcher-success">
                                                <input type="checkbox"/>
                                                <div className="switcher-indicator">
                                                    <div className="switcher-yes">ВКЛ</div>
                                                    <div className="switcher-no">ВЫКЛ</div>
                                                </div>
                                            </label>
                                        </td>
                                        <td className="p-a-2 valign-middle">
                                            <label className="switcher switcher-success">
                                                <input type="checkbox"/>
                                                <div className="switcher-indicator">
                                                    <div className="switcher-yes">ВКЛ</div>
                                                    <div className="switcher-no">ВЫКЛ</div>
                                                </div>
                                            </label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="p-a-2">Вы проиграли тендер</td>
                                        <td className="p-a-2 valign-middle">
                                            <label className="switcher switcher-success">
                                                <input type="checkbox"/>
                                                <div className="switcher-indicator">
                                                    <div className="switcher-yes">ВКЛ</div>
                                                    <div className="switcher-no">ВЫКЛ</div>
                                                </div>
                                            </label>
                                        </td>
                                        <td className="p-a-2 valign-middle">
                                            <label className="switcher switcher-success">
                                                <input type="checkbox"/>
                                                <div className="switcher-indicator">
                                                    <div className="switcher-yes">ВКЛ</div>
                                                    <div className="switcher-no">ВЫКЛ</div>
                                                </div>
                                            </label>
                                        </td>
                                        <td className="p-a-2 valign-middle">
                                            <label className="switcher switcher-success">
                                                <input type="checkbox"/>
                                                <div className="switcher-indicator">
                                                    <div className="switcher-yes">ВКЛ</div>
                                                    <div className="switcher-no">ВЫКЛ</div>
                                                </div>
                                            </label>
                                        </td>
                                        <td className="p-a-2 valign-middle">
                                            <label className="switcher switcher-success">
                                                <input type="checkbox"/>
                                                <div className="switcher-indicator">
                                                    <div className="switcher-yes">ВКЛ</div>
                                                    <div className="switcher-no">ВЫКЛ</div>
                                                </div>
                                            </label>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="panel">
                            <div className="panel-title"><strong>Периодические уведомления</strong></div>
                            <div className="panel-body">
                                <table className="table">
                                    <thead>
                                    <tr>
                                        <th className="p-a-2"></th>
                                        <th className="p-a-2">Email</th>
                                        <th className="p-a-2">SMS</th>
                                        <th className="p-a-2">В мобильном приложении</th>
                                        <th className="p-a-2">На рабочем столе</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td className="p-a-2">Новые тендеры</td>
                                        <td className="p-a-2 valign-middle">
                                            <label className="switcher switcher-success">
                                                <input type="checkbox"/>
                                                <div className="switcher-indicator">
                                                    <div className="switcher-yes">ВКЛ</div>
                                                    <div className="switcher-no">ВЫКЛ</div>
                                                </div>
                                            </label>
                                        </td>
                                        <td className="p-a-2 valign-middle">
                                            <label className="switcher switcher-success">
                                                <input type="checkbox"/>
                                                <div className="switcher-indicator">
                                                    <div className="switcher-yes">ВКЛ</div>
                                                    <div className="switcher-no">ВЫКЛ</div>
                                                </div>
                                            </label>
                                        </td>
                                        <td className="p-a-2 valign-middle">
                                            <label className="switcher switcher-success">
                                                <input type="checkbox"/>
                                                <div className="switcher-indicator">
                                                    <div className="switcher-yes">ВКЛ</div>
                                                    <div className="switcher-no">ВЫКЛ</div>
                                                </div>
                                            </label>
                                        </td>
                                        <td className="p-a-2 valign-middle">
                                            <label className="switcher switcher-success">
                                                <input type="checkbox"/>
                                                <div className="switcher-indicator">
                                                    <div className="switcher-yes">ВКЛ</div>
                                                    <div className="switcher-no">ВЫКЛ</div>
                                                </div>
                                            </label>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

export default ProfileNotifications;


// WEBPACK FOOTER //
// ./src/pages/Profile/Notifications/ProfileNotifications.js